(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('GpmAllRoundsOpen', GpmAllRoundsOpen);

    GpmAllRoundsOpen.$inject = ['$resource', 'DateUtils'];

    function GpmAllRoundsOpen($resource, DateUtils) {
        var resourceUrl = 'api/open/all-rounds-info/gpm';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
